/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Tue Mar 07 2023
 **/

import { Environments, Configure, Utility } from "../utilities";

const DefaultProperties: AllProperties = {
	get apiDomain() {
		const domain = Configure.api_domain; // Environments.env<string | null>("API_DOMAIN");
		return Utility.URLNormalize(domain);
	},
	get webDomain() {
		const domain = Configure.web_domain; // Environments.env<string | null>("WEB_DOMAIN");
		return Utility.URLNormalize(domain);
	},
	get webSocketDomain() {
		const domain = Environments.env<string | null>("WEBSOCKET_URI");
		return Utility.URLNormalize(domain);
	},
	get webSocketURL() {
		try {
			return new URL(this.webSocketDomain);
		} catch {
			return null;
		}
	},
	isActiveUnity: false,
	unityLoaded: false,
	unityVersion: "",
	isTabHidden: false,
	routerInfo: null,
	token: null,
	camera: {
		id: "",
		name: "",
		state: true,
		permission: true
	},
	microphone: {
		id: "",
		name: "",
		state: true,
		permission: true
	},
	focusStatus: {
		keyboardFocus: false,
		mouseFocus: false
	},
	user: null,
	firstLogin: false,
	firebaseToken: null,
	chatLanguage: "ko",
	phoneCallStatus: "IDLE",
	isUserStartViaSigninPage: false,
	mydeskWallpaper: "",
	widgets: [],
	callDeviceState: {
		audio: "on",
		video: "off"
	},
	// "voicechat" | "phonecall" | null
	currentMediaConnectionState: null,
	isGuest: false
};
export default DefaultProperties;
